// index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import i18n from 'i18next';
import { PrimeReactProvider } from 'primereact/api';
import App from './App';
import enTranslation from './Locales/en.json';
import hnTranslation from './Locales/hn.json';
import store from './State/store.js'; // Import the Redux store
import SnackbarProvider from './Components/Snackbar/snackBarProvider.js';

i18n.init({
  interpolation: { escapeValue: false },
  lng: 'en',
  resources: {
    en: {
      translation: enTranslation,
    },
    hn: {
      translation: hnTranslation,
    },
  },
});

const root = createRoot(document.getElementById('root'));
root.render(
  <PrimeReactProvider value={{ appendTo: document.body }}>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <SnackbarProvider>
          <App />
        </SnackbarProvider>
      </I18nextProvider>
    </Provider>
  </PrimeReactProvider>,
);
